import React, { useState } from "react";
import divicesImg from "../images/phones.png";
import expandImg from "../images/expander.png";

import config from '../config.json';
import Question from "../common/Question/Question";

function QuestionSection() {
  return (
    <section id="demo" className="wrapper wrapper-qa">
        <h4 className="section-title mb-24 text-center">
          Q&A
        </h4>
        <div className="flex mb-20 flex-row">
          <div className="flex flex-col text-center pb-12 md:pb-16">
              {config.questions.map((item, i) => (
                <Question item={item} key={i}/>
              ))}
          </div>
          <div className="flex justify-center h-fit">
            <img
              src={divicesImg}
              className="qa-img"
              alt="qa-bg "
            />
          </div>
        </div>
    </section>
  );
}

export default QuestionSection;
